import useAxiosInterceptor from 'src/services/interceptor';
import { apiPath, therapist } from '../constants';

type customHeader = {
  subdomain: string;
  facilityId: string;
  token: string;
};

const headersObject = {
  'Access-Control-Allow-Origin': '*',
  'Access-Control-Allow-Headers': 'Origin, X-Requested-With, Content-Type, Accept',
  'Access-Control-Allow-Methods': 'GET, POST, PUT, DELETE, OPTIONS',
};

class TherapistService {
  private axiosInstance;

  constructor() {
    this.axiosInstance = useAxiosInterceptor();
  }

  getTherapistProfile = () => {
    return this.axiosInstance.get(apiPath.GET_THERAPIST_PROFILE);
  };
  deletePatientTask = (payload: any) => {
    return this.axiosInstance.delete(
      `/provider/${payload?.providerId}/scheduling/${payload?.taskId}`
    );
  };

  autoMatchinTherapistSerivce = (payload: any) => {
    return this.axiosInstance.put(
      `/provider/${payload?.providerId}/scheduling/auto-assign?discipline=${payload?.discipline}&currentDate=${payload?.currentDate}`
    );
  };

  disableAutoMatchSerivce = (payload: any) => {
    return this.axiosInstance.get(
      `/provider/${payload?.providerId}/scheduling/enable-auto-match?discipline=${payload?.discipline}&currentDate=${payload?.currentDate}`
    );
  };

  defaultTherapistAssignSerivce = (payload: any) => {
    return this.axiosInstance.put(
      `/provider/patient/assign-therapist?therapistId=${payload?.therapistId}&discipline=${payload?.disciplineType}&assign=${payload?.assign}`,
      payload?.patientId
    );
  };

  getPayComeDetails = () => {
    return this.axiosInstance.get(apiPath.GET_PAY_COME_DETAILS);
  };

  getAllTherapists = (payload: object) => {
    return this.axiosInstance.get(therapist.getAll, {
      params: { ...payload },
    });
  };

  PreGetTherapistProfile = (payload: customHeader) => {
    return this.axiosInstance.get(apiPath.GET_THERAPIST_PROFILE, {
      headers: {
        Authorization: payload.token,
        Facility_id: payload.facilityId,
        'X-TENANT-ID': payload.subdomain,
        ...headersObject,
      },
    });
  };

  getTherapistsByRole = (role: string) => {
    return this.axiosInstance.get(therapist.getByRole(role));
  };

  getTherapistTaskNote = (payload: any) => {
    return this.axiosInstance.get(
      therapist.getTherapistTakNote(payload?.providerId, payload?.taskId)
    );
  };

  createTherapistTaskNote = (payload: any) => {
    return this.axiosInstance.put(
      therapist.createTherapistTakNote(payload?.providerId, payload?.taskId),
      payload?.data
    );
  };

  deleteTherapistTaskNote = (payload: any) => {
    return this.axiosInstance.delete(
      therapist.getTherapistTakNote(payload?.providerId, payload?.taskId)
    );
  };

  getAllAnnouncements = (payload: any) => {
    return this.axiosInstance.get(`/provider/announcement?localDate=${payload?.selectedDate}`);
  };

  createAnnouncement = (payload: any) => {
    const { providerId, ...resetPayload } = payload;
    return this.axiosInstance.post(
      `/provider/announcement`,
      {
        ...resetPayload,
      },
      { params: { providerId } }
    );
  };

  updateAnnouncement = (payload: any) => {
    return this.axiosInstance.put(
      `/provider/announcement/${payload?.uuid}`,
      {
        ...payload,
      },
      {
        params: { providerId: payload?.providerId },
      }
    );
  };

  deleteAnnouncement = (payload: any) => {
    return this.axiosInstance.delete(`/provider/announcement/${payload?.uuid}`, {
      ...payload,
    });
  };

  setCommonDuration = (payload: any) => {
    return this.axiosInstance.post(
      `/provider/${payload?.providerId}/scheduling/therapist/group-task/${payload?.groupUuid}?assignMin=${payload?.minutes}`
    );
  };
}

const therapistService = new TherapistService();

Object.freeze(therapistService);

export default therapistService;
